









/* Created- 24 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
@Component(
	{
		name: "ParticaCardFill"
	})
export default class ParticaCardFill extends Vue {
	@Prop() private title: string; // your data

	private getWidth() {
		return "98%";
	}
}
